<template>
	<div class="physics">
		<div class="red"></div>
		<div class="blue"></div>
	</div>
</template>

<script>

import EventBus from './../util/EventBus'
import Utils from './../util/Utils'
import Matter from 'matter-js'
import MatterAttractors from 'matter-attractors'
import SimplexNoise from 'simplex-noise'

export default {
  name: 'physics',
  data () {
    return {
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.simplexA = new SimplexNoise()
      this.simplexB = new SimplexNoise()
      this.timeA = 0
      this.timeB = 0
      this.isScrolling = false
      this.siteHeaderActive = true
      this.exhibitPillActive = true
      Matter.use(MatterAttractors)

	  // module aliases
      this.Engine = Matter.Engine
      this.Render = Matter.Render
      this.World = Matter.World
      this.Bodies = Matter.Bodies
      this.Common = Matter.Common
      this.MouseConstraint = Matter.MouseConstraint
      this.Mouse = Matter.Mouse
      this.Body = Matter.Body
      this.Sleeping = Matter.Sleeping
      this.Composite = Matter.Composite
      this.Composites = Matter.Composites

      // create an engine
      this.engine = this.Engine.create()
      this.engine.world.bounds.max.x = window.innerWidth
      this.engine.world.bounds.max.y = window.innerHeight
      this.engine.world.gravity.x = 0
      this.engine.world.gravity.y = 0

      this.container = document.getElementById('app')

      // create a renderer
      // this.renderer = this.Render.create({
      //   element: this.container,
      //   engine: this.engine,
      //   options: {
      //     width: window.innerWidth,
      //     height: window.innerHeight,
      //     showAngleIndicator: true,
      //     showCollisions: true,
      //     showVelocity: true,

      //     hasBounds: true,
      //     enabled: true,
      //     wireframes: true,
      //     showSleeping: true,
      //     showDebug: true,
      //     showBroadphase: true,
      //     showBounds: true,
      //     showVelocity: true,
      //     showCollisions: true,
      //     showSeparations: true,
      //     showAxes: true,
      //     showPositions: true,
      //     showAngleIndicator: true,
      //     showIds: true,
      //     showShadows: true,
      //     showVertexNumbers: true,
      //     showConvexHulls: true,
      //     showInternalEdges: true,
      //     showMousePosition: true
      //   }
      // })

      this.blue = document.querySelector('.blue')
      this.blueBounds = this.blue.getBoundingClientRect()

      this.red = document.querySelector('.red')
      this.redBounds = this.red.getBoundingClientRect()

      this.radiusA = this.blueBounds.width / 2
      this.radiusB = this.redBounds.width / 2

      this.diamA = this.blueBounds.width
      this.diamB = this.redBounds.width

      this.thickness = 2000
	    this.thickHalf = this.thickness / 2

		  let particleOptions = {
        friction: 0.05,
        frictionStatic: 0.1,
        render: { visible: true }
    	}

      // create two boxes and a ground
      this.ballA = this.Bodies.circle(this.radiusA + (Math.random() * (window.innerWidth - this.diamA)), this.radiusA + (Math.random() * (window.innerHeight - this.diamA)), this.radiusA, { frictionAir: 0.1, restitution: 0.2 })
      this.ballB = this.Bodies.circle(this.radiusB + (Math.random() * (window.innerWidth - this.diamB)), this.radiusB + (Math.random() * (window.innerHeight - this.diamB)), this.radiusB, { frictionAir: 0.1, restitution: 0.2 })
      //   this.ballA = this.Composites.softBody(this.radiusA + (Math.random() * (window.innerWidth - this.diamA)), this.radiusA + (Math.random() * (window.innerHeight - this.diamA)), 4, 4, 0, 0, true, this.radiusA / 4, particleOptions)
      //   this.ballB = this.Composites.softBody(this.radiusB + (Math.random() * (window.innerWidth - this.diamB)), this.radiusB + (Math.random() * (window.innerHeight - this.diamB)), 4, 4, 0, 0, true, this.radiusB / 4, particleOptions)
      this.ground = this.Bodies.rectangle(window.innerWidth / 2, window.innerHeight + this.thickHalf, 10000, this.thickness, { isStatic: true })
      this.top = this.Bodies.rectangle(window.innerWidth / 2, -this.thickHalf, 10000, this.thickness, { isStatic: true })
      this.left = this.Bodies.rectangle(-this.thickHalf, window.innerHeight / 2, this.thickness, 10000, { isStatic: true })
      this.right = this.Bodies.rectangle(window.innerWidth + this.thickHalf, window.innerHeight / 2, this.thickness, 10000, { isStatic: true })
      this.attractiveBody = this.Bodies.circle(
        window.innerWidth / 2,
        window.innerHeight / 2,
        50,
        {
          isStatic: true,
          // example of an attractor function that
          // returns a force vector that applies to bodyB
          plugin: {
            attractors: [
              function (bodyA, bodyB) {
                return {
                  x: (bodyA.position.x - bodyB.position.x) * 1e-6,
                  y: (bodyA.position.y - bodyB.position.y) * 1e-6
                }
              }
            ]
          }
        }
      )

      this.attractiveBody.collisionFilter.mask = 0x0008

	  this.mouse = this.Mouse.create(this.container)
	  this.mouse.element.addEventListener('mousemove', this.mouse.mousemove)
    this.mouse.element.addEventListener('mousedown', this.mouse.mousedown)
    this.mouse.element.addEventListener('mouseup', this.mouse.mouseup)
	  this.mouse.element.removeEventListener('mousewheel', this.mouse.mousewheel)
		this.mouse.element.removeEventListener('DOMMouseScroll', this.mouse.mousewheel)
		this.mouse.element.removeEventListener('touchstart', this.mouse.mousedown)
		this.mouse.element.removeEventListener('touchmove', this.mouse.mousemove)
		this.mouse.element.removeEventListener('touchend', this.mouse.mouseup)


      this.mouseConstraint = this.MouseConstraint.create(this.engine, {
        mouse: this.mouse,
        constraint: {
          stiffness: 0.2,
    		  render: {
            visible: false
          }
        }
      })

      EventBus.$on('app.resize', () => {
        this.onWindowResize()
      })
      EventBus.$on('app.deviceorientation', () => {
        this.updateGravity()
      })
      EventBus.$on('app.mousewheel', event => {
        this.onMouseWheel(event)
      })
      EventBus.$on('siteHeader.stop', () => {
        this.siteHeaderStop()
      })
      EventBus.$on('exhibitPill.stop', () => {
        this.exhibitPillStop()
      })
      this.originalMask = this.ballB.collisionFilter.mask

      this.$store.watch(() => this.$store.getters.getSiteHeader, (value) => {
        if (value === 'small') {
          this.siteHeaderLeave()
        } else if (value === 'big') {
           this.siteHeaderEnter()
        }
      }, { immediate: false })

      this.$store.watch(() => this.$store.getters.getExhibitPill, (value) => {
        if (value === 'small') {
          this.exhibitPillLeave()
        } else if (value === 'big') {
           this.exhibitPillEnter()
        }
      }, { immediate: false })

      this.$store.watch(() => this.$store.getters.getPhysicsB, (value) => {
        if (value) {
          this.physicsActivate()
        } else {
          this.physicsDeactivate()
          
        }
      }, { immediate: true })

      let defaultSize = 'tablet'

      this.$store.watch(() => this.$store.getters.getPhone, (value) => {
        if (value) {
          // console.log('its a phone')
          defaultSize = 'phone'
          this.Body.scale(this.ballA, 0.7, 0.7)
          this.Body.scale(this.ballB, 0.7, 0.7)
        } else if (defaultSize === 'phone') {
          // console.log('its a tablet')
          defaultSize = 'tablet'
          this.Body.scale(this.ballA, 1.4285714286, 1.4285714286)
          this.Body.scale(this.ballB, 1.4285714286, 1.4285714286)
        }
      }, { immediate: true })

      // console.log(this.$store.getters.getPhysicsB)

      // add all of the bodies to the world
      this.World.add(this.engine.world, [this.attractiveBody, this.ballA, this.ballB, this.ground, this.top, this.left, this.right, this.mouseConstraint])

      // this.renderer.mouse = this.mouse

      // keep the mouse in sync with rendering
      // run the renderer
      // this.Render.run(this.renderer)

      this.run()
    },
    run () {
      this.render()
      this.force()
      this.Engine.update(this.engine, 1000 / 60)
      window.requestAnimationFrame(this.run.bind(this))
    },
    force () {
      if (this.siteHeaderActive) this.timeA++
      if (this.exhibitPillActive) this.timeB++

      let xNoiseA = this.simplexA.noise2D(this.timeA * 0.001 + 3040, this.timeA * 0.001 + 41) * 0.005
      let yNoiseA = this.simplexA.noise2D(this.timeA * 0.001 + 837, this.timeA * 0.001 + 1839) * 0.005

      let xNoiseB = this.simplexB.noise2D(this.timeB * 0.001 + 3040 * 2, this.timeB * 0.001 + 41 * 9) * 0.005
      let yNoiseB = this.simplexB.noise2D(this.timeB * 0.001 + 837 * 5, this.timeB * 0.001 + 1839 * 4) * 0.005

      // let xNoiseA = simplexA.noise2D(time*0.001 + 3040, time*0.001 + 41) * 1.7
      // let yNoiseA = simplexA.noise2D(time*0.001 + 837, time*0.001 + 1839) * 1.7

      // let xNoiseB = simplexB.noise2D(time*0.001 + 3040*2, time*0.001 + 41*9) * 1.7
      // let yNoiseB = simplexB.noise2D(time*0.001 + 837*5, time*0.001 + 1839*4) * 1.7

      if (this.siteHeaderActive) this.Body.applyForce(this.ballA, { x: this.ballA.position.x, y: this.ballA.position.y }, { x: xNoiseA, y: yNoiseA })
	    if (this.exhibitPillActive) this.Body.applyForce(this.ballB, { x: this.ballB.position.x, y: this.ballB.position.y }, { x: xNoiseB, y: yNoiseB })

      //   this.Body.applyForce(bodies[1], { x: bodies[1].position.x, y: bodies[1].position.y }, { x: xNoiseA, y: yNoiseA })
      //   this.Body.applyForce(bodies[2], { x: bodies[2].position.x, y: bodies[2].position.y }, { x: xNoiseB, y: yNoiseB })

      // Body.translate( ballA, {x: xNoiseA, y: yNoiseA})
	  // Body.translate( ballB, {x: xNoiseB, y: yNoiseB})
      if (this.siteHeaderActive) this.Body.rotate(this.ballA, xNoiseA * 2)
      if (this.exhibitPillActive) this.Body.rotate(this.ballB, xNoiseB * 2)

        let gravity = this.engine.world.gravity

      if (!this.isScrolling) {
        gravity.y = Utils.lerp(gravity.y, 0, 0.1)
        gravity.x = Utils.lerp(gravity.x, 0, 0.1)
      }

      this.isScrolling = false

    },
    render () {
	  let bodies = this.Composite.allBodies(this.engine.world)
      let xA = bodies[1].position.x
      let yA = bodies[1].position.y
      let rA = Utils.toDegrees(bodies[1].angle)
      let xB = bodies[2].position.x
      let yB = bodies[2].position.y
	    let rB = Utils.toDegrees(bodies[2].angle)
	    EventBus.$emit('physics.ballA', { x: xA, y: yA, r: rA })
	    EventBus.$emit('physics.ballB', { x: xB, y: yB, r: rB })
      this.blue.style.transform = 'translate(' + xA + 'px, ' + yA + 'px) rotate(' + rA + 'deg)'
      this.red.style.transform = 'translate(' + xB + 'px, ' + yB + 'px) rotate(' + rB + 'deg)'
    },
    updateGravity () {
      if (this.siteHeaderActive && this.exhibitPillActive) {
        let orientation = typeof window.orientation !== 'undefined' ? window.orientation : 0
        let gravity = this.engine.world.gravity

        if (orientation === 0) {
          gravity.x = this.Common.clamp(event.gamma, -90, 90) / 90 * 14
          gravity.y = this.Common.clamp(event.beta, -90, 90) / 90 * 14
        } else if (orientation === 180) {
          gravity.x = this.Common.clamp(event.gamma, -90, 90) / 90 * 14
          gravity.y = this.Common.clamp(-event.beta, -90, 90) / 90 * 14
        } else if (orientation === 90) {
          gravity.x = this.Common.clamp(event.beta, -90, 90) / 90 * 14
          gravity.y = this.Common.clamp(-event.gamma, -90, 90) / 90 * 14
        } else if (orientation === -90) {
          gravity.x = this.Common.clamp(-event.beta, -90, 90) / 90 * 14
          gravity.y = this.Common.clamp(event.gamma, -90, 90) / 90 * 14
        }
      }
    },
    onWindowResize () {
      // this.renderer.canvas.width = window.innerWidth
      // this.renderer.canvas.height = window.innerHeight

      this.engine.world.bounds.max.x = window.innerWidth
      this.engine.world.bounds.max.y = window.innerHeight

      this.Body.setPosition(this.ground, { x: window.innerWidth / 2, y: window.innerHeight + this.thickHalf })
      this.Body.setPosition(this.top, { x: window.innerWidth / 2, y: -this.thickHalf })
      this.Body.setPosition(this.left, { x: -this.thickHalf, y: window.innerHeight / 2 })
      this.Body.setPosition(this.right, { x: window.innerWidth + this.thickHalf, y: window.innerHeight / 2 })
      this.Body.setPosition(this.attractiveBody, { x: window.innerWidth / 2, y: window.innerHeight / 2 })
    },
    onMouseWheel (event) {
      this.isScrolling = true
      if (this.siteHeaderActive && this.exhibitPillActive && !isNaN(event.deltaY)) {
      	let gravity = this.engine.world.gravity
        gravity.y = this.Common.clamp(-event.deltaY, -2, 2)
      }
    },
    siteHeaderEnter () {
      this.Body.scale(this.ballA, 1.8, 1.8)
      this.siteHeaderActive = false
    },
    siteHeaderStop () {
      this.siteHeaderActive = false
    },
    siteHeaderLeave () {
      this.Body.scale(this.ballA, 0.5555555556, 0.5555555556)
      this.siteHeaderActive = true
    },
    exhibitPillEnter () {
      this.Body.scale(this.ballB, 1.8, 1.8)
      this.exhibitPillActive = false
    },
    exhibitPillStop () {
      this.exhibitPillActive = false
    },
    exhibitPillLeave () {
      this.Body.scale(this.ballB, 0.5555555556, 0.5555555556)
      this.exhibitPillActive = true
    },
    physicsActivate () {
      this.ballB.collisionFilter.mask = this.originalMask
      this.Sleeping.set(this.ballB, false)
    },
    physicsDeactivate () {
      this.ballB.collisionFilter.mask = 0x0004
      this.Sleeping.set(this.ballB, true)
      this.exhibitPillActive = true
    }
  }
}
</script>

<style lang="scss">
  .physics {
  	width: 100vw;
  	height: 100vh;
  	height: var(--vh);
  	position: fixed;
  	top: 0;
  	left: 0;
  	// background: rgba(130, 130, 130, 0.3);
  	pointer-events: none;
  	z-index: 999999999;
  	// display: none;
  	visibility: hidden;
  	div {
  		width: 170px;
  		height: 170px;
  		left: -85px;
  		top: -85px;
  		position: absolute;
  		border-radius: 100%;

  		&.red {
  			background-image: linear-gradient(red, yellow);
  		}
  		&.blue {
  			background-image: linear-gradient(blue, green);
  		}
  	}
  }

  canvas {
  	position: fixed;
  	top: 0;
  	left: 0;
  	pointer-events: none;
  }
</style>
